export default {
    props: {
        messagesClear: {
            type: String,
            default: undefined,
            kComposite: 'messages.clear'
        },
        messagesDeleteTag: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteTag'
        },
        messagesSingleTag: {
            type: String,
            default: undefined,
            kComposite: 'messages.singleTag'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowntree-vue-wrapper/src/KendoDropDownTree/Messages.js